module.exports = __webpack_public_path__ + "img/stream.365c4049.svg";